module.exports = __webpack_public_path__ + "static/media/professionalSearch.65f2383b.svg";